

interface ErrorOverlayProps {
  message: string;
}

export const ErrorOverlay = ({ message }: ErrorOverlayProps) => {
  return (
    <div class="visualizer-error-overlay">
      <div class="visualizer-error-icon">⚠️</div>
      <div class="visualizer-error-message">{message}</div>
    </div>
  );
};
